import { RescheduleStep } from '@src/domains/sale-items/core/reschedule/types';

interface Params {
  currentStep: RescheduleStep;
  steps: RescheduleStep[];
  isWithDateOnly: boolean;
}

export function getPreviousRescheduleStep({ currentStep, steps, isWithDateOnly }: Params): RescheduleStep | undefined {
  const currentStepIndex = steps.indexOf(currentStep);
  const mustGoTwoStepsBack = isWithDateOnly && currentStep === RescheduleStep.Summary;

  return steps[currentStepIndex - (mustGoTwoStepsBack ? 2 : 1)];
}
